<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const loading = ref(true)
const errorMessage = ref(null)
const errorLines = ref([])

const route = useRoute()
const router = useRouter()

function setError(message) {
  // support string ou message multi-lignes
  if (Array.isArray(message)) {
    errorLines.value = message
  } else {
    errorLines.value = [message]
  }
  errorMessage.value = true
}

onMounted(() => {
  const paylineToken = route.params.paylineToken

  axios.post('/commandes/finaliser/' + paylineToken, {})
    .then(success => {
      loading.value = false

      if (success.status === 202) {
        setError("Ce paiement a déjà été traité.")
        return
      }

      if (typeof _paq === 'undefined') {
        window._paq = []
      }

      _paq.push([
        'trackEcommerceOrder',
        success.data.numeroCommande,
        success.data.montantCommande
      ])

      if (success.data.typeVente === 'VENTE') {
        router.push({
          name: 'succesAchat',
          query: {
            numeroCommande: success.data.numeroCommande,
            qrCodeUrl: success.data.qrCodeUrl
          }
        })
      } else if (success.data.typeVente === 'RECHARGEMENT') {
        router.push({
          name: 'succesRechargement',
          query: {
            numeroCommande: success.data.numeroCommande
          }
        })
      }
    })
    .catch(reason => {
      loading.value = false

      const status = reason?.response?.status

      if (status === 402) {
        setError([
          "Votre paiement a été refusé.",
          "Vous pouvez réessayer ou contacter la Boutique de la Mobilité pour plus de renseignements."
        ])
        return
      }

      if (status === 500) {
        setError([
          "Erreur lors de votre paiement.",
          "Vous pouvez réessayer ou contacter la Boutique de la Mobilité pour plus de renseignements."
        ])
        return
      }

      setError("Erreur avec le traitement de votre commande.")
    })
})
</script>

<template>
  <main
    class="text-center d-flex flex-column justify-content-center align-items-center"
    aria-labelledby="titre-statut"
  >
    <h1 id="titre-statut" class="visually-hidden">
      Statut de la commande
    </h1>

    <!-- Loading -->
    <section
      v-if="loading"
      class="container text-center p-3"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="spinner-border text-primary" aria-hidden="true"></div>

      <p class="mt-3 fs-5 text-wrap">
        Traitement de votre commande en cours
      </p>
    </section>

    <!-- Error -->
    <section
      v-else-if="errorMessage"
      class="container d-flex flex-column justify-content-center align-items-center text-center p-3"
      role="alert"
      aria-live="assertive"
    >
      <img
        src="@/assets/error.png"
        alt=""
        aria-hidden="true"
        class="img-fluid mb-3 rounded"
        style="max-width: 300px; width: 100%;"
      />

      <div class="alert fs-6 text-wrap">
        <p v-for="(line, i) in errorLines" :key="i" class="mb-1">
          {{ line }}
        </p>
      </div>
    </section>

  </main>
</template>

<style scoped lang="scss">

</style>
